"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highlightText = exports.getTextToHighlight = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _tokenMatcher = require("../../lib/utils/helper/tokenMatcher");

var fuzzball = _interopRequireWildcard(require("fuzzball"));

var getTextToHighlight = function getTextToHighlight(spanElements, searchText) {
  var TOKEN_SEPARATOR = ' ';
  var searchTextTokens = (0, _tokenMatcher.tokenize)(searchText);
  var maxSearchWindow = searchTextTokens.length * 3;
  var minSearchWindow = Math.max(1, Math.floor(searchTextTokens.length / 2));
  var allSpanElementTokens = [];

  var _loop = function _loop() {
    var spanIdx = _Object$keys[_i];
    var spanElement = spanElements[spanIdx];
    var spanElementTokens = (0, _tokenMatcher.tokenize)(spanElement.textContent);
    spanElementTokens.forEach(function (token) {
      token.spanElement = spanElement;
      token.globalTokenIndex = allSpanElementTokens.length;
      allSpanElementTokens.push(token);
    });
  };

  for (var _i = 0, _Object$keys = Object.keys(spanElements); _i < _Object$keys.length; _i++) {
    _loop();
  }

  var normalizedSearchStr = fuzzball.full_process(searchTextTokens.map(function (m) {
    return m.token;
  }).join(TOKEN_SEPARATOR));
  var bestLeft = 0;
  var bestRight = allSpanElementTokens.length;
  var bestScore = 0;
  var foundAnything = false;
  var allSearchTokensSet = new Set(searchTextTokens.map(function (t) {
    return t.token;
  }));

  for (var searchWindow = maxSearchWindow; searchWindow >= minSearchWindow; searchWindow--) {
    var foundBetter = false;
    var bestLeftCandidate = bestLeft;
    var bestRightCandidate = bestRight;

    for (var i = bestLeft; i < bestRight - searchWindow + 1; i++) {
      var currentTokens = allSpanElementTokens.slice(i, i + searchWindow).map(function (t) {
        return t.token;
      });
      var currentStr = currentTokens.join(TOKEN_SEPARATOR);
      var currentTokensSet = new Set(currentTokens);
      var foundSearchTokens = allSearchTokensSet.intersection(currentTokensSet);
      var tokenMatchRatio = foundSearchTokens.size / searchTextTokens.length;
      var score = fuzzball.ratio(normalizedSearchStr, currentStr) * tokenMatchRatio;

      if (score > bestScore) {
        bestScore = score;
        bestLeftCandidate = i;
        bestRightCandidate = i + searchWindow;
        foundBetter = true;
      }
    }

    if (foundBetter) {
      bestLeft = bestLeftCandidate;
      bestRight = bestRightCandidate;
      foundAnything = true;
    }
  }

  if (!foundAnything) return [];
  var longestSequence = allSpanElementTokens.slice(bestLeft, bestRight);
  return longestSequence;
};

exports.getTextToHighlight = getTextToHighlight;

var highlightText = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
    var textToHighlight,
        groupedBySpan,
        _iterator,
        _step,
        _step$value,
        spanElement,
        tokens,
        start,
        end,
        result,
        _args = arguments;

    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            textToHighlight = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};

            if (textToHighlight.length) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            groupedBySpan = new Map();
            textToHighlight.forEach(function (token) {
              var spanElement = token.spanElement;

              if (!groupedBySpan.has(spanElement)) {
                groupedBySpan.set(spanElement, []);
              }

              groupedBySpan.get(spanElement).push(token);
            });
            _iterator = (0, _createForOfIteratorHelper2.default)(groupedBySpan);
            _context.prev = 6;

            _iterator.s();

          case 8:
            if ((_step = _iterator.n()).done) {
              _context.next = 18;
              break;
            }

            _step$value = (0, _slicedToArray2.default)(_step.value, 2), spanElement = _step$value[0], tokens = _step$value[1];

            if (!(!spanElement || !tokens.length)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("continue", 16);

          case 12:
            // add <mark> to the first and </mark> to the last character of the span element
            start = tokens[0].index;
            end = tokens.at(-1).endIndex;
            result = spanElement.textContent.slice(0, start) + "<mark>".concat(spanElement.textContent.slice(start, end), "</mark>") + spanElement.textContent.slice(end);
            spanElement.innerHTML = result;

          case 16:
            _context.next = 8;
            break;

          case 18:
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](6);

            _iterator.e(_context.t0);

          case 23:
            _context.prev = 23;

            _iterator.f();

            return _context.finish(23);

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 20, 23, 26]]);
  }));

  return function highlightText() {
    return _ref.apply(this, arguments);
  };
}();

exports.highlightText = highlightText;